"use client";
import { Dialog } from "@ark-ui/react/dialog";
import { ark } from "@ark-ui/react/factory";
import { drawer, } from "@filadd/phi-plus-styled-system/recipes";
import { createStyleContext } from "../../utils";
const { withRootProvider, withContext } = createStyleContext(drawer);
export const RootProvider = withRootProvider(Dialog.RootProvider);
export const Root = withRootProvider(Dialog.Root);
export const Backdrop = withContext(Dialog.Backdrop, "backdrop");
export const CloseTrigger = withContext(Dialog.CloseTrigger, "closeTrigger");
export const Content = withContext(Dialog.Content, "content");
export const Description = withContext(Dialog.Description, "description");
export const Positioner = withContext(Dialog.Positioner, "positioner");
export const Title = withContext(Dialog.Title, "title");
export const Trigger = withContext(Dialog.Trigger, "trigger");
export const Header = withContext(ark.div, "header");
export const Body = withContext(ark.div, "body");
export const Footer = withContext(ark.div, "footer");
export { DialogContext as Context, } from "@ark-ui/react/dialog";
//# sourceMappingURL=Drawer.js.map